import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminCourses from './pages/AdminCourses';
import VerifyEmail from './pages/VerifyEmail';
import GuestPortal from './pages/GuestPortal';
import StoreLanding from './pages/StoreLanding';
import SetupAccount from './pages/SetupAccount';
import ActivatePurchase from './pages/ActivatePurchase';
import PaymentSuccess from './pages/PaymentSuccess';
import SupportAgentDashboard from './pages/SupportAgentDashboard';
import Scorecard from './pages/Scorecard';
import Learn from './pages/Learn';
import LearnPart from './pages/LearnPart';
import CertificateVerify from './pages/CertificateVerify';
import { Toaster } from 'sonner';
import { InstallPrompt } from './components/InstallPrompt';
import { LanguageProvider } from './contexts/LanguageContext';
import PWAUpdatePrompt from './components/PWAUpdatePrompt';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<StoreLanding />} />
            <Route path="/portal" element={<GuestPortal />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/backoffice" element={<Dashboard />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/courses" element={<AdminCourses />} />
            <Route path="/support" element={<SupportAgentDashboard />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/setup-account" element={<SetupAccount />} />
            <Route path="/activate-purchase" element={<ActivatePurchase />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/scorecard" element={<Scorecard />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/learn/:slug" element={<LearnPart />} />
            <Route path="/verify/:certId" element={<CertificateVerify />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <InstallPrompt />
        <PWAUpdatePrompt />
      </div>
    </LanguageProvider>
  );
}

export default App;
